import { CardInfoEntity, RoleInfoEntity } from "@/model/system";
import { RoleType, Sex, categoryMap, Categorys, CardType } from "@/model/Base";

export default class roleUtils {
  static BuildCard(cardType: number): CardInfoEntity {
    return Object.assign(new CardInfoEntity(), {
      CardID: "",
      CardType: cardType,
      CardNo: "",
      IssueDate: new Date(),
      ExpireDate: new Date(),
      IssueCountry: 151,
      RoleNick: "",
      RoleName: "",
      EnglishFirstName: "",
      EnglishLastName: "",
    });
  }
  static BuildRole() {
    return {
      ContactInfo: {
        ContactID: "",
        RoleID: "",
        ContactPeople: "",
        ContactPhone: "",
        ContactEmail: "",
      },
      Cards: [],
      RoleID: "",
      RoleName: "",
      RoleNick: "",
      RoleType: RoleType.User,
      RoleIcon: "",
      RoleGenre: Sex.Male,
      BirthDate: "1990-01-01",
      ContactID: "",
      FirstName: "",
      LastName: "",
      RoleIntro: "",
    };
  }
  /**
   * 构建证件类型列表
   * @param t 可选的翻译函数，用于国际化处理
   */
  static BuildCardTypes(t?: (key: string) => string) {
    let CardTypes: any = [];
    for (const key in categoryMap) {
      let category = categoryMap[key];
      if (category.BaseID != Categorys.CardType) {
        continue;
      }
      // 基础文本使用 CategoryName
      let text = category.CategoryName;
      // 如果提供了翻译函数，则进行翻译
      if (t) {
        text = t(`Categorys.${category.CategoryCode}`) || text;
      }
      CardTypes.push({ text, value: category.CategoryID, code: category.CategoryCode });
    }
    return CardTypes;
  }
  static CardRule() {
    // 代码	说明	规则
    // 709	居民身份证	18位或15位身份证
    // TRP	台湾居民居住证	4-18位字母或数字
    // GRP	港澳居民居住证	4-18位字母或数字
    // PT	护照	国内:4-18位字母或数字;    国际5-15位字母或数字（证件签发国区分国内证件还是国际）
    // 9CA	港澳通行证	8-9位字母或数字
    // 9CN	大陆居民往来中国台湾通行证	8-10位字母或数字
    // 710	外国人永久居留证	FNI 不区分大小写3位字母加12个数字
    // BR	出生证明	4到18位字母或者数字
    // HH	户口簿	同身份证
    // 9CT	台胞证	8位纯数字
    // 9CC	回乡证	11位字母或数字,第1位为字母
    // F1	其他	国内:4-18位字母或数字;
    // 国际5-15位字母或数字
    return {
      [CardType.IDCard]: /^(\w{15}|\w{18})$/gi,
      [CardType.PassportCard]: /^(\w{4,18})$/gi,
      [CardType.Taiwancompatriotsyndrome]: /^(\d{8})$/gi,
      [CardType.ReturnPermit]: /^(\w{1}\d{10})$/gi,
      [CardType.Residencebooklet]: /^(\w{15}|\w{18})$/gi,
      [CardType.birthcertificate]: /^(\w{4,18})$/gi,
      [CardType.OtherCard]: /^(\w{4,18})$/gi,
      [CardType.Residencepermit]: /^(\w{4,18})$/gi,
      [CardType.TaiwanResidencepermit]: /^(\w{4,18})$/gi,
      [CardType.ForeignResidentIDCard]: /^(\w{3}\d{12})$/gi,
      // [CardType.OfficerCard]: /^(\w{4,18})$/gi,
      // { text: "军人证", value: CardType.OfficerCard },
    };
  }
}
